import React from "react"
import { Link } from "gatsby"
import Map from "/src/components/Map"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebookSquare,
  faInstagram,
  faLine,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons"
import { faNewspaper } from "@fortawesome/free-solid-svg-icons"

import * as style from "./style.module.css"
import json from "/src/siteData.json"

import LogoImg from "../../images/common/logo.png";
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"

const data = json.footer

const Component = () => {
  return (
    <>
      <footer className={style.container}>
        <div className={style.fotter_main_group}>
          <figure className={style.logo_box}>
            <img src={LogoImg} alt={"株式会社さちなび"} />
          </figure>
          <Map address={data.address} />
          <div className={style.site}>
            <ul className={style.site_list}>
              <li className={style.site_item}>
                <Link to={"/"}>HOME</Link>
              </li>
              <li className={style.site_item}>
                <Link to={"/articles/p/1"}>BLOG</Link>
              </li>
              <li className={style.site_item}>
                <Link to={getPathFromTemplateType(2)}>会社概要</Link>
              </li>
              <li className={style.site_item}>
                <Link to={getPathFromTemplateType(3)}>施設紹介</Link>
              </li>
              <li className={style.site_item}>
                <Link to={"/facilty"}>施設紹介2</Link>
              </li>
              <li className={style.site_item}>
                <Link to={"/facilty_north"}>施設紹介3</Link>
              </li>

              <li className={style.site_item}>
                <Link to={"/recruit"}>採用情報</Link>
              </li>
              <li className={style.site_item}>
                <Link to={getPathFromTemplateType(5)}>Privacy Policy</Link>
              </li>
              <li className={style.site_item}>
                <Link to={getPathFromTemplateType(6)}>お問い合わせ</Link>
              </li>
            </ul>
          </div>

        </div>
        <div className={style.sns}>
          <ul className={style.sns_list}>
            {data.facebookUrl && (
              <li className={style.sns_item}>
                <Link to={data.facebookUrl}>
                  <FontAwesomeIcon
                    icon={faFacebookSquare}
                    style={{ fontSize: "2.2rem" }}
                    color="white"
                  />
                </Link>
              </li>
            )}
            {data.instagramUrl && (
              <li className={style.sns_item}>
                <Link to={data.instagramUrl}>
                  <FontAwesomeIcon
                    icon={faInstagram}
                    style={{ fontSize: "2.2rem" }}
                    color="white"
                  />
                </Link>
              </li>
            )}
            {data.lineUrl && (
              <li className={style.sns_item}>
                <Link to={data.lineUrl}>
                  <FontAwesomeIcon
                    icon={faLine}
                    style={{ fontSize: "2.2rem" }}
                    color="white"
                  />
                </Link>
              </li>
            )}
            {data.xUrl && (
              <li className={style.sns_item}>
                <Link to={data.xUrl}>
                  <FontAwesomeIcon
                    icon={faXTwitter}
                    style={{ fontSize: "2.2rem" }}
                    color="white"
                  />
                </Link>
              </li>
            )}
            {data.blogUrl && (
              <li className={style.sns_item}>
                <Link to={data.blogUrl}>
                  <FontAwesomeIcon
                    icon={faNewspaper}
                    style={{ fontSize: "2.2rem" }}
                    color="white"
                  />
                </Link>
              </li>
            )}
          </ul>
        </div>
        {data.copyright && (
          <div className={style.nav}>
            <small className={style.nav_copyright}>&copy; {data.copyright}</small>
          </div>
        )}
      </footer>
    </>
  )
}

export default Component
